import React, { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { Toast } from 'primereact/toast';
import constants from '../../../constants/constants';
import 'react-circular-progressbar/dist/styles.css';
import { Divider } from 'primereact/divider';
import { Chart } from 'primereact/chart';
import { Dropdown } from "primereact/dropdown";
import { Controller, useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useLocation, useHistory } from 'react-router-dom';
import axiosInstance from '../../../constants/axiosInstance';
import GanttChart from './GanttChart';
import classNames from "classnames";
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ExcelJS from "exceljs";
import html2canvas from "html2canvas";

const DashboardProjects = () => {
    const toast = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [records, setRecords] = useState();
    const [histogram, setHistogram] = useState();
    const [filteredProjectsRecords, setFilteredProjectsRecords] = useState();
    const [projectsData, setProjectsData] = useState();
    const [clientList, setClientList] = useState();
    const [userList, setUserList] = useState();
    const [CN, setCN] = useState('');
    const [PL, setPL] = useState('');
    const [PM, setPM] = useState();
    const [PO, setPO] = useState();
    const [YEAR, setYEAR] = useState();
    const setFilterProjects = useStoreActions((actions) => actions.projectModel.setFilterProjects);
    const filterProjects = useStoreState((actions) => actions.projectModel.filterProjects);
    const [projectName, setProjectName] = useState('');
    const [projectStatus, setProjectStatus] = useState('');
    const subTaskProjectName = useStoreState((actions) => actions.projectModel.subTaskProjectName);
    const setSubTaskProjectName = useStoreActions((actions) => actions.projectModel.setSubTaskProjectName);
    const subTaskRedirect = useStoreState((actions) => actions.projectModel.subTaskRedirect);
    const setSubTaskRedirect = useStoreActions((actions) => actions.projectModel.setSubTaskRedirect);
    const fromDashboard = useStoreState((actions) => actions.projectModel.fromDashboard);
    const setFromDashboard = useStoreActions((actions) => actions.projectModel.setFromDashboard);
    const ganttWorkbook = useStoreState((actions) => actions.projectModel.ganttWorkbook);
    const setGanttWorkbook = useStoreActions((actions) => actions.projectModel.setGanttWorkbook);
    const [tasks, setTasks] = useState();
    const [monthList, setMonthList] = useState();
    const [searchText, setSearchText] = useState('');
    const setEmployeeName = useStoreActions((actions) => actions.projectModel.setEmployeeName);
    const employeeName = useStoreState((actions) => actions.projectModel.employeeName);

    useEffect(() => {
        getDashboardData();
        getDashboardAllProjectData();
        getClientData();
        getUserList();
        setFilterProjects(null);
        getHistogramData();
        setSubTaskProjectName(null);
        setSubTaskRedirect(null);
        setFromDashboard(null);
    }, []);


    const defaultValues = { clientName: "", productionLocation: "", projectManager: "", projectObject: "", projectEndDate: "" };
    const form = useForm({ defaultValues });
    const { reset } = form;

    const getClientData = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.CLIENT_REGISTRY + "?page=1&limit=1000&sort_by=-created_at")
            .then((resp) => {
                setClientList(resp?.data?.data?.map((item) => {
                    return {
                        _id: item._id, customerName: item.customerName,
                    }
                }));
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const formatDate = (value) => {
        var date = value ? new Date(value) : null;
        return date?.toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });

    }
    const getUserList = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.URL.USERS + "?page=1&limit=1000&sort_by=-created_at")
            .then((resp) => {
                const userManagerRole = resp?.data?.data.filter(user => user.role.includes("manager") || user.role.includes("superadmin"))
                setUserList(userManagerRole);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const productionLocation = ["India", "France", "Tunisia", "Macedonia", "Mexico", "China"];
    const projectObject = ["Creation", "Modification", "Duplication", "Transfer"];

    const getDashboardData = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.PROJECTS_OVERALL_COUNT + "?" + `projectManager=&productionLocation=&client_id=&projectObject=`)
            .then((resp) => {
                setRecords(resp?.data?.data);
                reset();
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    };

    const getHistogramData = (data) => {

        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.PROJECT_HISTOGRAM + "?" + `projectName=${(projectName)}&projectStatus=${(projectStatus)}&productionLocation=${(data?.productionLocation ? data?.productionLocation : PL)}&client_id=${(data?.clientName ? data?.clientName : CN)}&projectObject=${(data?.projectObject || PO || '')}&projectManager=${(data?.projectManager || PM || '')}&projectEndDate=${(data?.projectEndDate ? data?.projectEndDate?.getFullYear() : '')}`)
            .then((resp) => {
                setHistogram(resp?.data?.data);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getHistogramData();
    }, [projectName, projectStatus]);

    const onSubmit = (data) => {
        const { projectManager, productionLocation, clientName, projectObject, projectEndDate } = data;

        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.PROJECTS_OVERALL_COUNT + "?" + `projectManager=${(projectManager)}&productionLocation=${(productionLocation)}&client_id=${(clientName)}&projectObject=${(projectObject)}&projectEndDate=${(data?.projectEndDate ? data?.projectEndDate?.getFullYear() : '')}`)
            .then((resp) => {
                setRecords(resp?.data?.data);
                setCN(clientName);
                setPL(productionLocation);
                setPO(projectObject);
                setPM(projectManager);
                setYEAR(projectEndDate);
                getHistogramData(data);
                // reset();
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    };

    const getDashboardAllProjectData = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.PROJECTS)
            .then((resp) => {
                setProjectsData(resp?.data?.data);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const filteredRecords = projectsData?.filter((item) => {
            const projectManagerMatch = PM ? item?.projectManager === PM : true;
            const productionLocationNameMatch = PL ? item?.productionLocation === PL : true;
            const clientNameMatch = CN ? item?.client_id?._id === CN : true;
            const projectObjectNameMatch = PO ? item?.projectObject === PO : true;
            const projectEndDateMatch = YEAR ? item?.projectEndDate?.includes(YEAR?.getFullYear()) : true;

            return projectManagerMatch && productionLocationNameMatch && projectObjectNameMatch && clientNameMatch && projectEndDateMatch
        })
        setFilteredProjectsRecords(filteredRecords);

        // Define a mapping of projectStatus to colors
        const statusColorMap = {
            "In-Progress": "#EFAF1E", // Yellow
            "Completed": "#5DDE32", // Green
            "Hold": "#B1B1B1", // Grey
        };

        const documentStyle = getComputedStyle(document.documentElement);
        const validStatuses = ["In-Progress", "Completed", "Hold"];
        const filteredDashboardProjectstatusData = filteredRecords?.filter(item => validStatuses.includes(item.projectStatus));
        const labels = filteredDashboardProjectstatusData?.map(item => item.projectName);
        const datas = filteredDashboardProjectstatusData?.map(item => item.completedPercentage);
        const backgroundColors = filteredDashboardProjectstatusData?.map(item => statusColorMap[item.projectStatus] || ""); // Default to light blue
        const textColor = documentStyle.getPropertyValue('--text-color');


        const data = {
            labels: labels,
            datasets: [
                {
                    label: 'Completed Percentage',
                    data: datas,
                    fill: false,
                    borderDash: [5, 5],
                    tension: 0.4,
                    borderColor: '#B4B4B4',
                    backgroundColor: backgroundColors,
                    pointBorderColor: backgroundColors,
                    pointBackgroundColor: backgroundColors,
                    borderWidth: 1,
                    pointRadius: 5, // Increases the size of the points
                    pointHoverRadius: 7, // Increases the size of points on hover
                },
            ],
        };

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    position: 'bottom', // Display legend at the bottom
                    labels: {
                        color: textColor
                    },
                    display: false,
                },
            },
            scales: {
                x: {
                    title: {
                        display: true, // Enable the label for X-axis
                        text: 'Project Names', // X-axis label text
                        color: "#212121", // Label color
                        font: {
                            size: 12, // Font size
                            weight: 600, // Font weight
                        },
                    },
                    grid: {
                        drawOnChartArea: false,
                    },
                },
                y: {
                    title: {
                        display: true, // Enable the label for Y-axis
                        text: 'Completion Percentage', // Y-axis label text
                        color: "#212121", // Label color
                        font: {
                            size: 12, // Font size
                            weight: 600, // Font weight
                        },
                    },
                    beginAtZero: true,
                    grid: {
                        drawOnChartArea: false,
                    },
                },
            },
        };

        setChartData(data);
        setChartOptions(options);
    }, [projectsData, CN, PL, PO, PM, YEAR]);

    const handleFilterProject = (value) => {
        const data = {
            cardValue: value, projectManager: PM, productionLocation: PL, clientName: CN, projectObject: PO, projectEndDate: YEAR ? (YEAR?.getFullYear()) : ""
        }
        setFilterProjects(data);
        history.replace("/app/projects-projects");

    }

    const handleClear = () => {
        setCN('');
        setPL('');
        setPO();
        setPM();
        setYEAR();
    }

    const [projectNameFilter, setProjectNameFilter] = useState('');
    const [projectStatusFilter, setProjectStatusFilter] = useState(null);

    const projectStatusOptions = ['Open', 'Hold', 'In-Progress', 'Completed'];

    const filteredData = (histogram || []).filter((item) => {
        const matchesName = projectNameFilter
            ? item.projectName.toLowerCase().includes(projectNameFilter.toLowerCase())
            : true;
        const matchesStatus = projectStatusFilter
            ? item.projectStatus.toLowerCase().includes(projectStatusFilter.toLowerCase())
            : true;
        return matchesName && matchesStatus && histogram;
    });

    const renderHeader = () => {
        return (
            <div className='flex justify-content-end gap-2 align-items-center'>
                <div className="">
                    <InputText type='search' value={projectNameFilter} onChange={(e) => setProjectNameFilter(e.target.value)} placeholder="Search Project Name" className="" />
                </div>
                <div className="">
                    <Dropdown value={projectStatusFilter} onChange={(e) => setProjectStatusFilter(e.value)} options={projectStatusOptions}
                        showClear placeholder="Search Project Status" className="w-full" style={{ minWidth: '200px' }} />
                </div>
            </div>
        );
    };

    const header = renderHeader();
    const generateMonthData = (start, end) => {
        const months = [];
        const current = new Date(start.getFullYear(), start.getMonth(), 1);
        while (current <= end) {
            months.push(current.toLocaleString("en-US", { month: "long", year: "numeric" }));
            current.setMonth(current.getMonth() + 1);
        }
        return months;
    };

    useEffect(() => {
        const taskItem = filteredProjectsRecords?.filter((item) => {
            const projectManagerMatch = filterProjects?.PM ? item?.projectManager === filterProjects?.PM : true;
            const productionLocationNameMatch = filterProjects?.PL ? item?.productionLocation === filterProjects?.PL : true;
            const clientNameMatch = filterProjects?.CN ? item?.client_id?._id === filterProjects?.CN : true;
            const projectObjectNameMatch = filterProjects?.PO ? item?.projectObject === filterProjects?.PO : true;
            const projectName = item?.projectName?.toLowerCase()?.includes(searchText?.toLowerCase());
            const projectEndDateMatch = filterProjects?.YEAR ? item?.projectEndDate?.includes(filterProjects?.YEAR?.getFullYear()) : true;

            return projectManagerMatch && productionLocationNameMatch && projectObjectNameMatch && clientNameMatch && projectName && projectEndDateMatch
        })?.flatMap((item) => ({
            projectName: item.projectName,
            list: item.taskHeader_id
                .map((taskHeader) => {
                    const status = taskHeader?.subTasks?.every((item) => item.subTaskStatus === "Open")
                        ? "Open"
                        : taskHeader?.subTasks?.every((item) => item.subTaskStatus === "Completed")
                            ? "Completed"
                            : "In-Progress";

                    return {
                        headerTitle: taskHeader.headerTitle,
                        startDate: taskHeader.subTasks.reduce((minDate, subTask) => {
                            if (!subTask.startDate) return minDate;
                            const subTaskDate = new Date(subTask.startDate);
                            return minDate ? (subTaskDate < new Date(minDate) ? subTask.startDate : minDate) : subTask.startDate;
                        }, null),
                        endDate: taskHeader.subTasks.reduce((maxDate, subTask) => {
                            if (!subTask.endDate) return maxDate;
                            const subTaskDate = new Date(subTask.endDate);
                            return maxDate ? (subTaskDate > new Date(maxDate) ? subTask.endDate : maxDate) : subTask.endDate;
                        }, null),
                        status,
                    };
                })
                .filter((taskHeader) => ["Open", "Completed"].includes(taskHeader.status)),
        }));

        const allDates = (taskItem ?? [])
            .flatMap(project =>
                (project.list ?? [])
                    .flatMap(task =>
                        task.startDate && task.endDate
                            ? [new Date(task.startDate), new Date(task.endDate)]
                            : []
                    )
            ).filter((item) => item);

        const minDate = new Date(Math.min(...allDates.map(date => date.getTime())));
        const maxDate = new Date(Math.max(...allDates.map(date => date.getTime())));

        const monthData = generateMonthData(minDate, maxDate);
        setMonthList(monthData);
        setTasks(taskItem);
    }, [filteredProjectsRecords, filterProjects, searchText]);


    // Helper function to format date to "MMM YYYY"
    const formatDateToMonth = (date) => {
        return date ? new Date(date).toLocaleString("en-US", { month: "long", year: "numeric" }) : '';
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "Completed":
                return { argb: "26C10D" }; // Green
            // Yellow
            case "Open":
                return { argb: "88A1E3" }; // Blue
            default:
                return { argb: "FFFFFF" }; // Transparent/White
        }
    };



    const exportExcelDashboard = async () => {
        setTimeout(async () => {
            try {
                const workbook = new ExcelJS.Workbook();

                // Sheet 1: Project Completion (Graph)
                const completionSheet = workbook.addWorksheet("Project Completion");

                // Capture the chart as an image
                const chartElement = document.querySelector(".chart-container");
                if (!chartElement) {
                    console.error("Chart not found");
                    return;
                }

                const canvas = await html2canvas(chartElement);
                const imageData = canvas.toDataURL("image/png");

                // Add image to Excel
                const imageId = workbook.addImage({
                    base64: imageData,
                    extension: "png",
                });

                completionSheet.addImage(imageId, {
                    tl: { col: 1, row: 1 },
                    ext: { width: 800, height: 450 },
                });

                // Sheet 2: Project Progress Histogram (Tabular Data)
                const progressSheet = workbook.addWorksheet("Project Progress Histogram");

                const progressData = filteredProjectsRecords?.map((item) => ({
                    "Project Name": item.projectName,
                    "Customer": item?.client_id?.customerName || '',
                    "Year": item.projectEndDate
                        ? new Date(item.projectEndDate).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })
                        : '',
                    "Project Completion (%)": item.completedPercentage || '',
                    "Production Location": item.productionLocation || '',
                    "Project Status": item.projectStatus || '',
                }));

                if (progressData && progressData.length > 0) {
                    const headers = Object.keys(progressData[0]);
                    const headerRow = progressSheet.addRow(headers);

                    // Style Headers
                    headerRow.eachCell((cell) => {
                        cell.font = { bold: true, size: 12 };
                        cell.alignment = { horizontal: "left" };
                    });

                    // Add Data Rows
                    progressData.forEach((row) => {
                        progressSheet.addRow(Object.values(row));
                    });

                    // Adjust Column Widths
                    progressSheet.columns = headers.map((header) => ({
                        header,
                        key: header,
                        width: header === "Customer" ? 30 : Math.max(15, header.length + 6),
                    }));
                }

                // ✅ Sheet 3: Gantt Chart
                const ganttSheet = workbook.addWorksheet("Gantt Chart");

                ganttSheet.getCell("A1").value = `User: ${employeeName}`;
                ganttSheet.getCell("A1").font = { bold: true, size: 12 };
                ganttSheet.getCell("A1").alignment = { vertical: "middle", horizontal: "left" };

                ganttSheet.getCell("D1").value = "■ Open";
                ganttSheet.getCell("D1").font = {
                    name: "Calibri",
                    size: 14,
                    bold: true,
                    color: { argb: "88A1E3" },
                };

                ganttSheet.getCell("E1").value = "■ Completed";
                ganttSheet.getCell("E1").font = {
                    name: "Calibri",
                    size: 14,
                    bold: true,
                    color: { argb: "FF26C10D" },
                };

                // === Row 2: Spacer
                ganttSheet.addRow([]);

                // === Row 3: Column headers
                const headerRow = ganttSheet.getRow(3);
                headerRow.values = [
                    "Project Name",
                    "Start Date",
                    "End Date",
                    ...monthList
                ];
                headerRow.font = { bold: true, size: 12 };
                headerRow.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "D3D3D3" },
                };

                // === Set column widths manually
                ganttSheet.getColumn(1).width = 40; // Project Name
                ganttSheet.getColumn(2).width = 15; // Start Date
                ganttSheet.getColumn(3).width = 15; // End Date
                monthList.forEach((_, i) => {
                    ganttSheet.getColumn(4 + i).width = 15;
                });

                // === Add data starting from row 4
                let currentRow = 4;
                // Add project and subtask rows
                tasks.forEach((task) => {
                    const projectRowIndex = currentRow++;
                    ganttSheet.addRow([]);
                    ganttSheet.mergeCells(`A${projectRowIndex}:C${projectRowIndex}`);
                    const projectCell = ganttSheet.getCell(`A${projectRowIndex}`);
                    projectCell.value = task.projectName;
                    projectCell.font = { bold: true };
                    projectCell.alignment = { vertical: "middle", horizontal: "left" };


                    task.list.forEach((subItem) => {
                        const row = ganttSheet.getRow(currentRow++);
                        row.getCell(1).value = subItem.headerTitle;
                        row.getCell(2).value = formatDateToMonth(subItem.startDate);
                        row.getCell(3).value = formatDateToMonth(subItem.endDate);

                        const borderColor = subItem?.status === "Completed" ? "26C10D" : "88A1E3";
                        row.getCell(1).border = {
                            left: { style: "double", color: { argb: borderColor } },
                        };

                        const startIndex = monthList.findIndex(
                            (month) => month === formatDateToMonth(subItem.startDate)
                        );
                        const endIndex = monthList.findIndex(
                            (month) => month === formatDateToMonth(subItem.endDate)
                        );

                        monthList.forEach((_, index) => {
                            if (index >= startIndex && index <= endIndex) {
                                const cell = row.getCell(4 + index);
                                cell.value = "";
                                cell.fill = {
                                    type: "pattern",
                                    pattern: "solid",
                                    fgColor: getStatusColor(subItem.status),
                                };
                            }
                        });
                    });
                });

                //Save the Excel File
                const buffer = await workbook.xlsx.writeBuffer();
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "Dashboard_Report.xlsx");

            } catch (error) {
                console.error("Error exporting Excel:", error);
            }
        }, 100);
    };





    return (
        <>
            <Toast ref={toast} />
            {/* <h3 className="PS-title m-0">Dashboard</h3> */}
            <div className="flex align-items-center justify-content-between">
                <div>
                    <h3 className="PS-title m-0">Dashboard</h3>
                </div>
                <div>
                    <Button className="btn-black mx-2" label="Download" onClick={exportExcelDashboard} />
                </div>
            </div>
            <Divider />
            <div>
                <div className='col-12'>
                    <div className='grid sticky-header'>
                        <div className='col-12'>
                            <div className="dashboard-card">
                                <form onSubmit={form.handleSubmit(onSubmit)} className="error_msg">
                                    <div className='flex lg:col-12 md:col-12 sm:flex-container md:flex-row m-0 p-0 sm:flex-column dash-drop-3'>
                                        <div className="lg:col-2 md:col-2 my-2">
                                            <span className="w-full">
                                                <Controller
                                                    name="clientName"
                                                    control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <Dropdown filter options={clientList} optionLabel="customerName" optionValue="_id" value={field.value || ""} placeholder={isLoading ? "Loading..." : "Customer"} disabled={isLoading} onChange={(e) => { field.onChange(e.value); }} style={{ width: '100%' }} />
                                                    )}
                                                />
                                            </span>
                                        </div>
                                        <div className="lg:col-2 md:col-2 my-2">
                                            <span className="w-full">
                                                <Controller
                                                    name="projectManager"
                                                    control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <Dropdown filter value={field.value || ""} onChange={(e) => field.onChange(e.target.value)}
                                                            options={userList} optionLabel="first_name" optionValue='first_name' placeholder={isLoading ? "Loading..." : "Project Manager"} disabled={isLoading} style={{ width: '100%' }} />
                                                    )}
                                                />
                                            </span>
                                        </div>
                                        <div className="lg:col-2 md:col-2 my-2">
                                            <span className="w-full">
                                                <Controller
                                                    name="productionLocation"
                                                    control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <Dropdown id='productionLocation' options={productionLocation} value={field.value || ""} placeholder={isLoading ? "Loading..." : "Production Location"} disabled={isLoading}
                                                            onChange={(e) => field.onChange(e.target.value)} style={{ width: '100%' }} />
                                                    )}
                                                />
                                            </span>
                                        </div>
                                        <div className="lg:col-2 md:col-2 my-2">
                                            <span className="w-full">
                                                <Controller
                                                    name="projectObject"
                                                    control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <Dropdown options={projectObject} value={field.value || ""} placeholder={isLoading ? "Loading..." : "Object"} disabled={isLoading}
                                                            onChange={(e) => field.onChange(e.target.value)} style={{ width: '100%' }} />
                                                    )}
                                                />
                                            </span>
                                        </div>
                                        <div className="lg:col-2 md:col-2 my-2">
                                            <span className="w-full">
                                                <Controller
                                                    name="projectEndDate"
                                                    control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <Calendar id={field.name} dateFormat="yy" view="year" value={field.value || ""} className={classNames({ "p-invalid": fieldState.error })} onChange={(e) => field.onChange(e.target.value)} showIcon placeholder="Year" style={{ width: '100%' }} />
                                                    )}
                                                />
                                            </span>
                                        </div>
                                        <div className='lg:col-2 md:col-2 flex align-items-center my-2'>
                                            {/* <div className='project_search flex justify-content-end w-full align-items-center' style={{ marginRight: '5px' }}> */}
                                            <div><Button className="btn-black-user" label="Clear" onClick={() => { form.reset({ clientName: "", projectManager: "", productionLocation: "", projectObject: "", projectEndDate: "" }, { keepErrors: false, }); getDashboardData(); handleClear(); }} /></div>
                                            <div className='mx-2'><Button size="small" loading={isLoading} label="Search" className="btn-yellow-user" /></div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className='grid' >
                        <div className='col-12 md:col-6 lg:col-4'>
                            <div onClick={() => handleFilterProject("")} className='flex hod-Project'>
                                <div style={{ width: '60%' }}>
                                    <div className='small-cards text-center' >
                                        <h2 className='dash_pro_stats_value'>{records?.totalProject}</h2>
                                        <h5 className='dash_pro_stats_title'>Total Projects</h5>
                                    </div>
                                </div>
                                <div className='admin-dash-image' style={{ width: '40%' }}>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 md:col-6 lg:col-4'>
                            <div onClick={() => handleFilterProject("In-Progress")} className='hod-Project flex'>
                                <div style={{ width: '60%' }}>
                                    <div className='small-cards text-center'>
                                        <h2 className='dash_pro_stats_value'>{records?.onGoingProjects}</h2>
                                        <h5 className='dash_pro_stats_title mb-0'>On Going Projects</h5>
                                    </div>
                                </div>

                                <div className='admin-dash2-image' style={{ width: '40%' }}>
                                    {/* <img src={Icon1} alt='icon1' /> */}
                                </div>
                            </div>
                        </div>
                        <div className='col-12 md:col-6 lg:col-4'>
                            <div onClick={() => handleFilterProject("Completed")} className='hod-Project flex'>
                                <div style={{ width: '60%' }}>
                                    <div className='small-cards text-center'>
                                        <h2 className='dash_pro_stats_value '>{records?.completedProjects}</h2>
                                        <h5 className='dash_pro_stats_title mb-0'>Completed Projects</h5>
                                    </div>
                                </div>
                                <div className='admin-dash3-image' style={{ width: '40%' }}>
                                    {/* <img src={Group} alt='group' /> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='grid mt-3'>
                        <div className='col-12'>
                            <div className="card">
                                <h3 className="PS-title m-0">Project Completion</h3>
                                <Divider />
                                <div className='flex justify-content-end align-items-center mb-3'>
                                    <div className='on-going-projects'></div><span className='status'>On Going Projects</span>
                                    <div className='completed-projects'></div><span className='status'>Completed Projects</span>
                                    <div className='hold-projects'></div><span className='status'>Hold Projects</span>
                                    {/* <div className='open-projects'></div><span className='status'>Open</span> */}
                                </div>


                                <div className='flex justify-content-center chart-container'>
                                    <Chart type="line" data={chartData} options={chartOptions} className="w-full" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='grid mt-3'>
                        <div className='col-12'>
                            <div className='histogram-sticky'>
                                <div className='align-items-center flex justify-content-between text-center'>
                                    <h3 className="PS-title m-0">Project Progress Histogram</h3>
                                    <div>
                                        {header}
                                    </div>
                                </div>
                                <Divider />
                            </div>
                            <div className="col-12">
                                <DataTable tableStyle={{ minWidth: '50rem' }} value={filteredData} removableSort rows={10} paginator loading={isLoading} >
                                    <Column field="projectName" header="Project Name" className='user-project-header' sortable bodyClassName="user-project-bodyColumn"
                                        bodyStyle={{ padding: '0px' }}
                                        body={(rowData) => (
                                            <div style={{ display: 'flex', alignItems: 'center', }}>
                                                <span
                                                    style={{

                                                        borderLeft: "6px solid",
                                                        borderLeftColor:
                                                            rowData.projectStatus === "In-Progress" ? "#EFAF1E" :
                                                                rowData.projectStatus === "Completed" ? "#5DDE32" :
                                                                    rowData.projectStatus === "Hold" ? "#B1B1B1" :
                                                                        rowData.projectStatus === "Open" ? "#B5E0F8" : "#FFFFFF",
                                                        height: '35px',
                                                        marginRight: '8px'
                                                    }}
                                                />
                                                {rowData.projectName}
                                            </div>
                                        )}> </Column>
                                    <Column field="client_id.customerName" header="Customer" sortable className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '170px' }}></Column>
                                    <Column field="projectEndDate" header="Year" sortable body={(rowData) => (<p>{formatDate(rowData.projectEndDate)}</p>)} className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '150px' }}></Column>
                                    <Column field="completedPercentage" header="Project Completion" sortable
                                        body={(rowData) => (<div> {rowData?.completedPercentage !== undefined && rowData?.completedPercentage !== null ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(rowData.completedPercentage) + "%" : ""} </div>)}
                                        className='user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                                    <Column field="productionLocation" header="Production Location" sortable className='user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                                    <Column field="projectStatus" header="Project Status" sortable className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '150px' }} />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                    <GanttChart toGantt={filteredProjectsRecords} />
                </div>
            </div>
        </>
    );
}

export default DashboardProjects;